import React, { useEffect, useReducer, useState } from 'react';

import { useAuth } from '../../Context';
import { Content } from 'antd/es/layout/layout';
import { Avatar, Button, Card, Col, Empty, Form, Input, message, Modal, Popover, Row,  Space, Spin,  Table,  Tag,  Typography } from 'antd';
import {  DeleteOutlined, DiffOutlined, EditOutlined, InfoOutlined, PlusOutlined } from '@ant-design/icons';
import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';
import axios from 'axios';
import ScriptReducer from './reducer';
import { ADD_SCRIPT_LIST, ADD_SCRIPT_LIST_ERROR, ADD_SCRIPT_LIST_SUCCESS, DELETE_SCRIPT_LIST, DELETE_SCRIPT_LIST_ERROR, DELETE_SCRIPT_LIST_SUCCESS, SCRIPT_LIST, SCRIPT_LIST_DETAILS, SCRIPT_LIST_DETAILS_ERROR, SCRIPT_LIST_DETAILS_SUCCESS, SCRIPT_LIST_ERROR, SCRIPT_LIST_SUCCESS, SCRIPT_LIST_UPDATE, SCRIPT_LIST_UPDATE_SUCCESS, SCRIPT_LISTL_UPDATE_ERROR } from './constants';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
// import { Option } from 'antd/es/mentions';


const { Title } = Typography;

export default function Scripts() {
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const initalState = { loading: false, error: false,details:null, scriptdata : [], pagination: { total: 0, limit: 10, skip: 0, current:1 }};
	const [data, dispatch] = useReducer(ScriptReducer, initalState);
	const [isAddModalOpen, setIsAddModalOpen] = useState(false);
	const [openEditDrawer, setOpenEditDrawer] = useState(false);
	const [showDeletescriptModal, setShowDeletescriptModal] = useState(false);
	
	const featuresModule = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_FEATURES_MODULE_DASHBOARD`));

	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);
	

	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;	
	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	
	const navigate = useNavigate();
	
	useAuth();
	
	useEffect(() => {
		if(!authtoken){
			navigate('/');
		}
		if(featuresModule.scriptsEnabled == false) {
			navigate('/dashboard');
		}
		window.scrollTo(0, 0);
		localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' ,4030);
		loadscripts();
	}, []);
	
	
	const loadscripts= ()=>{
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/scripts/?&$sort[id]=-1`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				Authorization:`Bearer ${authtoken}`				
			},
		};
		dispatch({type : SCRIPT_LIST});
		axios.request(config)
			.then((response) => {
				if(response.status == 200 || response.status == 201){	
									
					dispatch({ type : SCRIPT_LIST_SUCCESS, payload: response.data.data });
				} else {
					dispatch({ type : SCRIPT_LIST_ERROR});			
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : SCRIPT_LIST_ERROR });
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				} else {
					// Modal.warning({ title: langdata && langdata.Unabletoupdatealgorithm ? langdata.Unabletoupdatealgorithm : 'Unable to update algorithm.' });											
				}
			});
	};

	const deltehandler = (record) =>{
		loadScriptDetails(record);
		openDeleteScriptModal();
	};

	const edithandler = (record) =>{
		loadScriptDetails(record);
		showEditDrawer();
	};

	const openDeleteScriptModal = () => {
		// setShowDeleteGeofenceManagementModal(true);
		setShowDeletescriptModal(true);
	};
		
	const closeDeleteScriptModal = () => {
		setShowDeletescriptModal(false);
	};

	const deletescripts = () => {
		const id = parseInt(data.details.id);
			
		dispatch({ type: DELETE_SCRIPT_LIST });
		
		let config = {
			method: 'delete',
			maxBodyLength: Infinity,
			url: `${api}/scripts/${id}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};
		
		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({type: DELETE_SCRIPT_LIST_SUCCESS, payload: response});
					setShowDeletescriptModal(false);   
					loadscripts();       
				} else {
					dispatch({type:DELETE_SCRIPT_LIST_ERROR});  
				}
			})
			.catch((error) => {
				dispatch({type:DELETE_SCRIPT_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};


	const columns = [
		{
			title: langdata && langdata.Name ? langdata.Name : 'Name',
			dataIndex: 'name',
			key: 'name',
		},
		{
			title:langdata && langdata.productionStatus ? langdata.productionStatus : 'Production Status',
			dataIndex: 'productionStatus',
			key: 'productionStatus',
			render: (record) => (
				<Space wrap>
					{record?.length ? 
						record.map(item => {
							
							return (
								<Tag color={'blue'} key={item} 
								>
									{item}
								</Tag>
							);
						}) : 
						<Tag color={ 'yellow'}>
							{'Nil'}
						</Tag>
					}
				</Space>	
			)
			
		},
		{
			title: langdata && langdata.thresholdSecs ? langdata.thresholdSecs : 'Threshold Secs (s)',
			dataIndex: 'thresholdSecs',
			key: 'thresholdSecs',
		
		},
		{
			title: `${langdata&&langdata.isPidsSpecific?langdata.isPidsSpecific:'Pids Specific'}`,
			dataIndex: 'isPidsSpecific',
			key: 'isPidsSpecific',
			render: (_, record) => (
				<Tag  color={record.isPidsSpecific === false ? 'red': 'green'} >
					{record.isPidsSpecific === false ? 'False' : 'True'}
				</Tag>
			),
		},
		{
			title: `${langdata&&langdata.scheduleSecs?langdata.scheduleSecs:'Schedule Secs (s)'}`,
			dataIndex: 'scheduleSecs',
			key: 'scheduleSecs',
			render: (record)=>(
				record === null ? 'NIL' : record 
			)
		},
		{
			title: `${langdata && langdata.Actions ? langdata.Actions:'Actions'}`,
			key: '',
			align:'center',
			width : 100,

			render: (_,record) => (
						
		
				<>
					<Space style={{justifyContent:'center',display:'flex'}} size="middle">
						<a title={langdata && langdata.Edit ? langdata.Edit:'Edit'}  onClick={()=>edithandler(record)}><EditOutlined/></a>
						<a title={langdata && langdata.Delete ? langdata.Delete :'Delete'} onClick={()=>deltehandler(record)}><DeleteOutlined /></a>

					</Space>
				</>
			)
		}
	];

	const handleOk = () => {
		setIsAddModalOpen(false);
		createFormik.resetForm();
	};
	const handleCancel = () => {
		setIsAddModalOpen(false);
		createFormik.resetForm();

	};
	const showEditDrawer = () => {
		setOpenEditDrawer(true);
		formik.resetForm();
	};	
	const handleModalCancel = () => {
		setOpenEditDrawer(false);
		formik.resetForm();
	};

	const createFormik = useFormik({
		// enableReinitialize: true,
		initialValues : {
			name : null,
			productionStatus : [],
			thresholdSecs : null,
			isPidsSpecific : true,
			scheduleSecs : null
		},
		onSubmit: (values) => {
			const {name, thresholdSecs, scheduleSecs, productionStatus} = values;
			
			if( name == null || name == ''|| name == undefined ){
				Modal.warning({title : langdata && langdata.PleaseEnterName ? langdata.PleaseEnterName : 'Please Enter Name'});
				return false;
			}
			if( thresholdSecs == null || thresholdSecs == undefined ){
				Modal.warning({title : langdata && langdata.PleaseEnterThresholdSecs ? langdata.PleaseEnterThresholdSecs : 'Please Enter Threshold Secs'});
				return false;
			}
		
			
			dispatch({ type : ADD_SCRIPT_LIST });
			let data = JSON.stringify({
				name : name,
				productionStatus : productionStatus,
				thresholdSecs :  thresholdSecs,
				scheduleSecs : scheduleSecs
				
			});

			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `${api}/scripts`,
				timeout: timeout,
				headers: { 
					'Content-Type': 'application/json', 
					Authorization:`Bearer ${authtoken}`
				},
				data : data
			};

			axios.request(config)
				.then((response) => {
					if(response.status == 200 || response.status == 201){	
						Modal.success({ title: langdata && langdata.ScriptsAddedSuccessfully ? langdata.ScriptsAddedSuccessfully : 'Scripts Added Successfully' });	
									
						dispatch({ type : ADD_SCRIPT_LIST_SUCCESS  } );
						loadscripts();	
						createFormik.resetForm();
						setIsAddModalOpen(false);
					} else {
						dispatch({ type : ADD_SCRIPT_LIST_ERROR });
						Modal.warning({ title: langdata && langdata.Unabletoadd ? langdata.Unabletoadd : 'Unable to add' });					
					}
				})
				.catch((error) => {
					console.log(error);
					dispatch({ type : ADD_SCRIPT_LIST_ERROR });
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					} else {
						Modal.warning({ title: langdata && langdata.Unabletoadd ? langdata.Unabletoadd : 'Unable to add' });					
					}
				});

		}
	});	

	const infoContent = (
		<Card size="small" bordered="false" type="inner" style={{ width: 300 }}> 
			<p style={{textAlign:'justify'}}> {langdata && langdata.scriptsModuleInfo ? langdata.scriptsModuleInfo : 'This module is used to manage different scripts, including their scheduling configuration and execution settings.'} </p>
		</Card>
	);

	const formik = useFormik({
		enableReinitialize: true,
		initialValues: {
			name:  data?.details?.name || '',
			productionStatus: data?.details?.productionStatus || [],
			thresholdSecs:  data?.details?.thresholdSecs || null,
			scheduleSecs: data?.details?.scheduleSecs || null,
			
		},
		onSubmit: (values) => {
			const {name,  thresholdSecs} = values;
			const scheduleSecs = values.scheduleSecs ? values.scheduleSecs : null;
			const productionStatus = values.productionStatus ? values.productionStatus : [];
		
			dispatch({type:SCRIPT_LIST_UPDATE});
			let config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: `${api}/scripts/${data?.details?.id}`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${authtoken}`
				},
				data: {
					name : name,
					productionStatus : productionStatus,
					thresholdSecs :  thresholdSecs,
					scheduleSecs : scheduleSecs
					
				}
			}; 
			axios
				.request(config)
				.then((response) => {
					if (response.status === 200) {

						dispatch( { type: SCRIPT_LIST_UPDATE_SUCCESS, payload: response.data.data });
						Modal.success({ title: `${langdata && langdata.ScriptUpdatedSuccessfully ? langdata.ScriptUpdatedSuccessfully :'Script Updated Successfully'}` });
						formik.resetForm();
						setOpenEditDrawer(false);
						loadscripts();
					}
				})
				.catch((error) => {
					console.log(error);
					dispatch({ type: SCRIPT_LISTL_UPDATE_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
						});
					}
				});
	
		}
	});

	const loadScriptDetails = ((record) => {
		dispatch( { type: SCRIPT_LIST_DETAILS });
			
		if (!record) {
			dispatch({ type: SCRIPT_LIST_DETAILS_ERROR });
		} else {
			dispatch({ type: SCRIPT_LIST_DETAILS_SUCCESS, payload: record });
		
		}
		
	});
	const addtexthandler = (e)=>{
		const productionStatus = e.target.value ?  e.target.value.split(',') : [];
		createFormik.setFieldValue('productionStatus',productionStatus);

	};

	const edittexthandler = (e)=>{
		const productionStatus = e.target.value ?  e.target.value.split(',') : [];
		formik.setFieldValue('productionStatus',productionStatus);
	};

	return (
		permission==='superadmin' ? 
			<>
		
		
				<Content>
					<Row style={{
						margin: '10px',
						paddingLeft: '10px',
						paddingRight: '10px',
						background: '#FFFFFF',
						alignItems:'center',
					}}
					>
						<Col span={8}>
							<Row>
								<Space>
									<DiffOutlined style={{fontSize:'30px'}}/>
								</Space>
								<Space>&nbsp;&nbsp;</Space>
								<Title level={4} style={{ paddingTop:'10px'}}>{langdata && langdata.Scripts ? langdata.Scripts : 'Scripts'}</Title>
							</Row>
						</Col>
						<Col span={16}>
							<Row justify="end">
								<Col>
									{/* <Text style={{ display: 'flow', paddingTop: '4px', textAlign: 'end',  marginRight: '4px' }}>User Type:</Text> */}
									{ permission==='superadmin' || permission === 'admin' ? 
										<Space>
											<Space>&nbsp;</Space>
											<Button style={{margin:'5px'}} type="primary" onClick={() => {setIsAddModalOpen(true);}}><PlusOutlined/>{langdata && langdata.AddNew ? langdata.AddNew : 'Add New'}</Button>
										</Space>
										: null }
									<Space>&nbsp;&nbsp;&nbsp;</Space>
							
									<Popover title={langdata && langdata.Scripts ? langdata.Scripts : 'Scripts'}  content={infoContent} trigger="click">
										<Avatar size="small"><InfoOutlined/></Avatar>
									</Popover>
								</Col>
							</Row>
						</Col>
					</Row>
					<Row span={24} style={{
						margin: '10px',
						paddingLeft: '10px',
						paddingRight: '10px',
						background: '#FFFFFF',
						alignItems:'center'
					}} >
						<Col span={24}>
							{ data.scriptdata && data.scriptdata && data.scriptdata.length > 0 ? (
								<Table
									scroll={{
										x: 900,
									}}
									columns = { columns } 
									dataSource = { data.scriptdata } 
									onChange={loadscripts}
									onRow = {() => {
										return {
											onClick: () => { 
											// loadPredictionlevelDetails(record);
									
									
											}
										};
									}}
								/>
							)
								:
								(
									<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
								)}
						</Col>
					</Row>


					<Modal
						title={langdata && langdata.AddScripts ? langdata.AddScripts : 'Add Scripts'}
						centered
						open={isAddModalOpen}
						onOk={handleOk}
						onCancel={handleCancel}
						maskClosable={false}
						destroyOnClose= {true}
						footer={[
							// eslint-disable-next-line react/jsx-key
							<Space>
								<Button onClick={handleCancel}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE'}</Button>
								<Button type="primary"  onClick={createFormik.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE'}</Button>
							</Space>
						]}
						width={500}
					>
						<Form layout="vertical" >
							<Row gutter={24}>
								<Col span={24}>
									<Form.Item label={langdata && langdata.Name ? langdata.Name : 'Name'} rules={[{ required: true, message: langdata && langdata.Pleasefillthename ? langdata.Pleasefillthename : 'Please fill the name' }]} required>
										<Input 
											name="name" 
											placeholder={langdata && langdata.Pleasefillthename ? langdata.Pleasefillthename : 'Please fill the name'}
											onChange={createFormik.handleChange} 
										/>
									</Form.Item>
								</Col>
							</Row>
					
						</Form>
						<Form layout="vertical" >
							<Row gutter={24}>
								<Col span={24}>
									<Form.Item label={langdata && langdata.productionStatus ? langdata.productionStatus :  'Production Status'} rules={[{ required: false, message: langdata && langdata.PleaseEnterProductionStatus ? langdata.PleaseEnterProductionStatus : 'Please Enter Production Status' }]} >
										<Input 
											name="productionStatus" 
											placeholder={langdata && langdata.PleaseEnterProductionStatus ? langdata.PleaseEnterProductionStatus : 'Please Enter Production Status'}
											onChange={(e)=>addtexthandler(e)} 
										/>
									</Form.Item>
								</Col>
							</Row>
					
						</Form>
						<Form layout="vertical" >
							<Row gutter={24}>
								<Col span={24}>
									<Form.Item label={langdata && langdata.thresholdSecs ? langdata.thresholdSecs : 'Threshold Secs (s)'} rules={[{ required: true, message: langdata && langdata.PleaseEnterProductionStatus ? langdata.PleaseEnterProductionStatus : 'Please Enter Threshold Secs' }]} required>
										<Input
											type='number'
											min={0} 
											name="thresholdSecs" 
											placeholder={langdata && langdata.PleaseEnterThresholdSecs ? langdata.PleaseEnterThresholdSecs : 'Please Enter Threshold Secs'}
											onChange={createFormik.handleChange} 
										/>
									</Form.Item>
								</Col>
							</Row>
					
						</Form>
						<Form layout="vertical" >
							<Row gutter={24}>
								<Col span={24}>
									<Form.Item label={langdata&&langdata.scheduleSecs?langdata.scheduleSecs:'Schedule Secs (s)'} rules={[{ required: false, message: langdata && langdata.PleaseEnterScheduleSecs ? langdata.PleaseEnterScheduleSecs : 'Please Enter Schedule Secs' }]} >
										<Input 
											name="scheduleSecs"
											type='number'
											min={0}  
											placeholder={langdata && langdata.PleaseEnterScheduleSecs ? langdata.PleaseEnterScheduleSecs : 'Please Enter Schedule Secs' }
											onChange={createFormik.handleChange} 
										/>
									</Form.Item>
								</Col>
							</Row>
					
						</Form>
					</Modal>

					<Modal
						title={langdata && langdata.EditScripts ? langdata.EditScripts:'Edit Scripts'}
						width={500}
						centered
						destroyOnClose={true}
						maskClosable={false}
						onOk={formik.handleSubmit}
						onCancel={handleModalCancel}
						open={openEditDrawer}
						styles={{
							body: {
							},
						}}
						footer={[
							// eslint-disable-next-line react/jsx-key
							<Space>
								<Button onClick={handleModalCancel}>
									{langdata && langdata.CANCEL ? langdata.CANCEL:'CANCEL'}
								</Button>
								<Button onClick={formik.handleSubmit} type="primary">
									{langdata && langdata.SAVE ? langdata.SAVE:'SAVE'}
								</Button>
							</Space>
						]}
					>
						<Form onSubmit={formik.handleSubmit} layout="vertical"
					
						>
							<Row gutter={24}>
								<Col span={24}>
									<Form.Item label={langdata && langdata.Name ? langdata.Name:'Name'} rules={[{ required: false, message: `${langdata && langdata.Name ? langdata.Name:'Name'}` }]}>
										<Input name="name" value={formik.values.name} onChange={formik.handleChange} defaultValue={data?.details?.name}  placeholder={langdata && langdata.Name ? langdata.Name:'Name'} />
									</Form.Item>
								</Col>
							</Row>
						</Form>
						<Form layout="vertical" >
							<Row gutter={24}>
								<Col span={24}>
									<Form.Item label={langdata && langdata.productionStatus ? langdata.productionStatus :  'Production Status'} rules={[{ required: false, message: langdata && langdata.PleaseEnterProductionStatus ? langdata.PleaseEnterProductionStatus : 'Please Enter Production Status' }]} >
										<Input 
											name="productionStatus" 
											placeholder={langdata && langdata.PleaseEnterProductionStatus ? langdata.PleaseEnterProductionStatus : 'Please Enter Production Status'}
											defaultValue={data?.details?.productionStatus}
											onChange={(e)=>edittexthandler(e)}   
										/>
									</Form.Item>
								</Col>
							</Row>
					
						</Form>
						<Form layout="vertical" >
							<Row gutter={24}>
								<Col span={24}>
									<Form.Item label={langdata && langdata.thresholdSecs ? langdata.thresholdSecs : 'Threshold Secs (s)'} rules={[{ required: true, message: langdata && langdata.PleaseEnterProductionStatus ? langdata.PleaseEnterProductionStatus : 'Please Enter Threshold Secs' }]} required>
										<Input
											type='number'
											min={0} 
											name="thresholdSecs" 
											placeholder={langdata && langdata.PleaseEnterThresholdSecs ? langdata.PleaseEnterThresholdSecs : 'Please Enter Threshold Secs'}
											onChange={formik.handleChange} 
											defaultValue={data?.details?.thresholdSecs}  
										/>
									</Form.Item>
								</Col>
							</Row>
					
						</Form>
						<Form layout="vertical" >
							<Row gutter={24}>
								<Col span={24}>
									<Form.Item label={langdata&&langdata.scheduleSecs?langdata.scheduleSecs:'Schedule Secs (s)'} rules={[{ required: false, message: langdata && langdata.PleaseEnterScheduleSecs ? langdata.PleaseEnterScheduleSecs : 'Please Enter Schedule Secs' }]} >
										<Input 
											name="scheduleSecs"
											type='number'
											min={0}  
											placeholder={langdata && langdata.PleaseEnterScheduleSecs ? langdata.PleaseEnterScheduleSecs : 'Please Enter Schedule Secs' }
											onChange={formik.handleChange} 
											defaultValue={data?.details?.scheduleSecs}
										/>
									</Form.Item>
								</Col>
							</Row>
					
						</Form>
					</Modal>
					<Modal title={langdata && langdata.Confimdelete ? langdata.Confimdelete : 'Confirm delete'} open={showDeletescriptModal} onOk={deletescripts} onCancel={closeDeleteScriptModal}>
						<Row style={{
							marginTop: '10px',
							marginBottom: '10px',
							background: '#FFFFFF',
							alignItems:'center'
						}} >
							<Col span={1}>
								<DeleteOutlined  style={{ fontSize: '14px'}}/>
							</Col>
							<Col span={23}> { langdata && langdata.Areyousureyouwanttodeletethis ? langdata.Areyousureyouwanttodeletethis : 'Are you sure you want to delete this' }</Col>
						</Row>
					</Modal>
					<Spin fullscreen spinning={data.loading} />
				</Content>
			</> : null
	);
}